module.exports = __webpack_public_path__ + "static/media/mapFallout.15bd6fee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mapFallout.png
// module id = 854
// module chunks = 0